import { getTypes } from "./TypeGenerator";

export const StudentTypes = {
    ...getTypes("STUDENT"),
    UPDATE_STUDENT_PROFILE: "UPDATE_STUDENT_PROFILE",
    UPDATE_STUDENT_PROFILE_SUCCESS: "UPDATE_STUDENT_PROFILE_SUCCESS",
};
